import React, { useState } from "react";
import { IconButton, useMediaQuery } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import JDPCustomButton1 from "./JDPCustomButton1";
import JDPCustomButtonMenu1 from "./JDPCustomButtonMenu1";

const ExpandableJDPACustomButton1 = ({open, onClick}) => {

    const isMobile = useMediaQuery('(max-width: 768px)');

    if (!isMobile) {
        return <JDPCustomButton1 />;
    }

    return (
        <div>
            <div className="menu-category-title-row clickable-row" onClick={onClick}>
                <span className="menu-category-title">Vehicles For Sale</span>
                <IconButton size="small" className="expandable-icon">
                    {open ? <RemoveIcon className="expandable-icon" /> : <AddIcon className="expandable-icon" />}
                </IconButton>
            </div>
            {open && (
                <div className="expandable-content">
                    <JDPCustomButtonMenu1 />
                </div>
            )}
        </div>
    );
};

export default ExpandableJDPACustomButton1;